import React, { createContext, useState } from 'react';
import { createTheming } from '@callstack/react-theme-provider';

import defaultTheme from './assets/Themes/DefaultTheme';

import config from './config';
const env = process.env.REACT_APP_CLIENT_ENV || 'development';

const { ThemeProvider, useTheme } = createTheming(defaultTheme);

const Context = createContext();

const Themes = [{ name: 'base', styles: defaultTheme }];

const ThemeProviderWrapper = ({ children }) => {
  const [theme, setTheme] = useState(
    localStorage.getItem('APP_THEME') || config[env].theme
  );

  const currentTheme =
    Themes.find((theme) => theme.name === theme) ||
    Themes.find((theme) => theme.name === config[env].theme);

  return (
    <Context.Provider value={{ theme, setTheme }}>
      <ThemeProvider theme={currentTheme.styles}>{children}</ThemeProvider>
    </Context.Provider>
  );
};

export { ThemeProviderWrapper, useTheme, Context as ThemeContext };
